import { redirect } from "@tanstack/react-router";

import { getItemSessionStorage } from "@/lib/utils";
import { ELocalStorageKeys } from "@/app/types/localStorage";

export const validateAuthToken = () => {
  const accessToken = getItemSessionStorage(ELocalStorageKeys.TOKEN);
  if (!accessToken) {
    throw redirect({ to: "/login" });
  }
};
